'use strict'

export default {
    BASE_URL: import.meta.env.VITE_API_URL,
    TOKEN_URL: import.meta.env.VITE_API_TOKEN_URL,
    SAML_SSO_URL: import.meta.env.VITE_SAML_SSO_URL,
    ENV: import.meta.env.VITE_ENV
}
